import { Dispatch, SetStateAction, useState } from 'react';

import { useLocalStorage } from './useLocalStorage';
import { usePropChange } from './usePropChange';

export type UseLocalStorageStateResult<T> = [value: T, setValue: Dispatch<SetStateAction<T>>];

export function useLocalStorageState<T>(key: string): UseLocalStorageStateResult<T | undefined>;

export function useLocalStorageState<T>(key: string, initialValue: T): UseLocalStorageStateResult<T>;

export function useLocalStorageState<T>(key: string, initialValue?: T): UseLocalStorageStateResult<T | undefined> {
  const { getValue, setValue } = useLocalStorage<T>(key);
  const [state, setState] = useState<T | undefined>(() => getValue() || initialValue);

  if (usePropChange(state)) {
    setValue(state);
  }

  return [state, setState];
}
